goog.provide('el8.uiwidget.Icd10ListEditor');

goog.require('el8.service.infoField');
goog.require('el8.service.tooltip');
goog.require('el8.template.uiwidget.Icd10ListEditor');

//
// A widget for displaying and managing ICD-10-based Dx lines with an optiional "show dual coding"
// inline checkbox.
//
// If the "multiple" flag is set, the caller should insert and manage the "show dual coding"
// checkbox and associate state (e.g. billing dlg)
//
// In the billing dlg, There will be one of these per MLE entry:
// - a container for the ICD-10 Dx lines
// - a input for an IMO mindreader
//
var ICD10Codes = [
  "Z68.1",
  "Z68.20",
  "Z68.21",
  "Z68.22",
  "Z68.23",
  "Z68.24",
  "Z68.25",
  "Z68.26",
  "Z68.27",
  "Z68.28",
  "Z68.29",
  "Z68.30",
  "Z68.31",
  "Z68.32",
  "Z68.33",
  "Z68.34",
  "Z68.35",
  "Z68.36",
  "Z68.37",
  "Z68.38",
  "Z68.39",
  "Z68.40",
  "Z68.41",
  "Z68.42",
  "Z68.43",
  "Z68.44",
  "Z68.45",
  "Z68.51",
  "Z68.52",
  "Z68.53",
  "Z68.54",
]

el8.uiwidget.Icd10ListEditor = function(opts) {
    this._opts = opts || {};
};

el8.uiwidget.Icd10ListEditor.prototype.init = function() {
    var that = this;

    // Required:
    // the selector of the container to append ICD-10 lines to
    this.$listContainer = jQuery.isFunction(this._opts.listContainer) ? this._opts.listContainer() : this._opts.listContainer;
    // the "parent" Form object
    this._form = this._opts.form;
    // Required callback for after we've selected an IMO
    this._onImoSelectFn = this._opts.onImoSelectFn;

    // Optional:
    // index of a "parent" MLE entry or 0 if there's only one
    this._index = (this._opts.index !== null) ? this._opts.index : null;
    this._sortable = (this._opts.sortable === true); // default false

    // Note: The "show dual coding" inline checkbox is shown by default under the dx lines. If the
    // "multiple" flag is set (e.g. the billing dialog) then there are multiple copies of this widget
    // in the form and then the caller is responsible for adding it's own checkbox and managing
    // its state.
    this._multiple = (this._opts.multiple === true); // default false
    // add an inline "show dual coding checkbox" below the 10 lines

    // Internal:
    // template that represents one ICD-10 row
    this._templateFn = el8.template.uiwidget.Icd10ListEditor.icd10Line;

    // defaults to the user preference, but not valid if there are multiple LEs (like in the bill dlg)
    this._showDualCoding = !this._multiple ? el8.data.currUser.isShowDualCodingEnabled() : null;

    this._onAddEntry = this._opts.onAddEntry || null;
    this._onRemoveEntry = this._opts.onRemoveEntry || null;

    // the MR opts
    var MRopts = {
        formatSelected: function(item) {
            return ''; // clear input
        },
        selectFn: function(event, item, mindreader) {
            that._onImoSelectFn(that, item, that._index);
        },
        modifyRenderCb: function(args) {
            if (args.numMatches === 0) {
                args.infoDiv.text( 'No results found for "' + args.searchString + '"');
            } else {
                if (args.infoDiv.is(':visible')) {
                    // show the HCC header if flag on
                    var tmpl = null;
                    if (el8.data.practiceSettings.isHccScoringEnabled()) {
                        tmpl = el8.template.appshared.imo.termListHeaderWithHCC;
                    } else {
                        tmpl = el8.template.appshared.imo.termListHeader;
                    }
                    args.mrSections[0].prepend(tmpl({mindreader: true}));
                }
            }
        }
    };

    var mrOpts = $.extend(el8.appshared.mindreaderOpts.imosWithActiveAndRecentProblems('icd10'), MRopts);
    if (this._form) {
        this._form.addField({
            name: this._index === null ? 'dxs' : 'dxs_'+this._index,
            selector: this._index === null ? ':input[name="dxs"]' : ':input[name="dxs_'+this._index+'"]',
            infoText: 'Add Dxs',
            height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
            maxLength: 20,
            newMindreader: true,
            mindreaderOpts: mrOpts
        });
    } else {
        var $input = $(':input[name="dxs"]', this.$listContainer.parent());
        el8.service.infoField.addInfoField({
            field: $input,
            maxLength: 20,
            infoText: 'Add Dxs',
            height: el8.util.consts.DEFAULT_FIELD_HEIGHT
        });
        (new el8.uiwidget.NewMindreader(mrOpts)).init($input);
    }

    this._bindTriggers();

    // don't add an initial row, just return this
    return this;
};

el8.uiwidget.Icd10ListEditor.prototype.setShowDualCoding = function (bool) {
    // invalid if multiple is true
    if (!this._multiple) { this._showDualCoding = bool ? Boolean(bool) : false; }
    return this._showDualCoding;
};

el8.uiwidget.Icd10ListEditor.prototype.getShowDualCoding = function () {
    return this._showDualCoding;
};

el8.uiwidget.Icd10ListEditor.prototype._bindTriggers = function () {
    var that = this;

    this.$listContainer.on('click', '.remove-icd10-line-trigger',  function() {
        var $this = $(this);
        var $icd10Line =  $this.closest('.billing-icd10-line');
        that.removeEntry($icd10Line.data('index'));
        if (that._sortable) { that.$listContainer.sortable('refresh'); }
        if (that._onRemoveEntry) { that._onRemoveEntry(); }
    });

    // Don't bind this if we have multiple Icd10ListEditors
    if (!this._multiple) {
        $(this.$listContainer.parent()).on('click', '.dual-coding-checkbox',  function() {
            that._showDualCoding = $(this).is(':checked');
            if (that._showDualCoding) {
                $('.billing-icd9-list', this.$listContainer).show();
            } else {
                $('.billing-icd9-list', this.$listContainer).hide();
            }
        });
    }
};

el8.uiwidget.Icd10ListEditor.prototype.addNewEntry = function(dxMap, noFocus, index) {
    if (index === undefined) {
        index = this.getLastEntryIndex() + 1;
    }

    var that = this;
    if (!dxMap || !dxMap.icd10Code) { return; }

    // silently prevent dups from being inserted
    if (_.contains(this.getIcdIdLists()['icd10Ids'], dxMap.icd10Code.id)) { return; }

    var _templateOpts = $.extend({
        index: index,
        sortable: this._sortable,
        // Usually we want the widget's current state of showDualCoding, but the exception
        // is if the caller is manually managing that state (e.g. the bill dlg). In that
        // case, use the passed in value from dxMap
        showDualCoding: that._multiple ? dxMap._showDualCoding : that._showDualCoding
    },
    dxMap);

    // show the inline checkbox under the dx lines
    if (!this._multiple) {
        var $checkboxSection = $('.dual-coding-checkbox-section', this.$listContainer.parent());
        $checkboxSection.show();
        // make sure it's checked appropriately when added
        if (this._showDualCoding) {
            $('.dual-coding-checkbox', $checkboxSection).prop('checked', true);
        }
    }

    var str = this._templateFn(_templateOpts);
    // Weird issue with jquery's (or browser's) parsing of the HTML when doing $(str) which was
    // incorrectly removing the outer <div> from the HTML string. To fix, sending the HTML string
    // to append directly.

    if (index > 0){
        $(str).insertAfter(this.$listContainer.children()[index-1]);
    }else {
        this.$listContainer.prepend(str);
    }


    if (this._sortable) { this.$listContainer.sortable('refresh'); }
    this.createTooltip($(str), dxMap);
    this.labelEntries();

    if (!noFocus) {
        // deferred focus will pop back up the DX mindreader
        _.defer(function() { $('.billing-dx-input', that.$listContainer.parent()).focus(); });
    }

    if (this._onAddEntry) { this._onAddEntry(); }

    return index;
};

el8.uiwidget.Icd10ListEditor.prototype.removeEntry = function(index) {
    var $entry = this.$listContainer.find('.billing-icd10-line[data-index="'+index+'"]');
    $entry.remove();

    // if we removed last, remove the checkbox too
    if (!this._multiple && (this.getLastEntryIndex === -1)) {
        $('.dual-coding-checkbox-section', this.$listContainer.parent()).hide();
    }
    this.labelEntries();
};

el8.uiwidget.Icd10ListEditor.prototype.removeAllEntries = function() {
    _.each(this.$listContainer.find('.billing-icd10-line'), function (line) {
        var $line = $(line);
        this.destroyTooltip($line);
        $(line).remove();
    }, this);
};
el8.uiwidget.Icd10ListEditor.prototype.reset = function() {
    this.removeAllEntries();
};

el8.uiwidget.Icd10ListEditor.prototype.getLastEntryIndex = function() {
    if (this.$listContainer.find('.billing-icd10-line').length) {
        return this.$listContainer.find('.billing-icd10-line').last().data('index');
    } else {
        return -1;
    }
};

el8.uiwidget.Icd10ListEditor.prototype.getEntryCount = function() {
  return this.$listContainer.find('.billing-icd10-line').length;
};

el8.uiwidget.Icd10ListEditor.prototype.getIcdIdLists = function() {
    var icd9Ids = [];
    var icd10Ids = [];

    _.each(this.$listContainer.find('.billing-icd10-line'), function (line) {
        icd10Ids.push($(line).data('id'));

        _.each($('.billing-icd9', line), function(icd9elt) {
            icd9Ids.push($(icd9elt).data('id'));
        });
    });

    return {
        icd9Ids: _.compact(icd9Ids),
        icd10Ids: _.compact(icd10Ids)
    };
};

el8.uiwidget.Icd10ListEditor.prototype.repopulateFromIdLists = function(idListObj, noFocus) {
    // we just get two flat lists of 10s and 9s (and not the association b/w them).
    // just apply 9s to the first 10
    var that = this;

    var icd9Codes = _.map(idListObj.icd9Ids, function (icd9Id) {
        return el8.data.icd9Codes.getById(icd9Id).asSoyMap();
    });

    _.each(idListObj.icd10Ids, function(icd10Id, index) {
        that.addNewEntry({
            icd9Codes: index === 0 ? icd9Codes : [],
            icd10Code: el8.data.icd10Codes.getById(icd10Id).asSoyMap()
        }, noFocus);
    });
};

// labelEntries is called on sort, add, and remove. It will reorder the indices
// so that we don't run into any troubles with duplicate data-index values
el8.uiwidget.Icd10ListEditor.prototype.labelEntries = function(elt) {
    _.each(this.$listContainer.find('.billing-icd10-line'), function(line, idx) {
        // need to do 3 things to the line:
        // 1. change the cached index on the jquery data object
        // 2. manipulate the dom so index is correctly reflected
        // 3. set the Dx number for the line (Dx1:)
        $(line).data('index', idx)
            .attr('data-index', idx)
            .find('.billing-icd10-label').text(idx + 1);
    });
};

el8.uiwidget.Icd10ListEditor.prototype.createTooltip = function($line, dxMap) {
    _.each(dxMap.icd9Codes, function(icd9Code) {
        el8.service.tooltip.create({
            anchor: $('span[data-id="'+icd9Code.id+'"]', $line).first(),
            text: el8.template.appshared.imo.tooltip({
                code: icd9Code.code,
                codeType: 'ICD-9',
                description: icd9Code.description
            }),
            placement: 'top',
            theme: 'gray',
            showDelay: 300 ,
            interactive: true
        });
    });
};

el8.uiwidget.Icd10ListEditor.prototype.destroyTooltip = function($line) {
    _($line.find('span.has-tippy')).each(function (elt) {
        el8.service.tooltip.destroy($(elt));
    });
};